<template>
    <div class="backend">

        <h1>Here comes the backend</h1>

        <fieldset>
            <legend>Cockpits</legend>

            <table style="width:100%;">
                <tr>
                    <td>Name</td>
                    <td>Bildquelle</td>
                </tr>
                <tr v-for="(cockpit, idx) in cockpits" v-bind:key="cockpit.value">
                    <td class="cockpitpreview">
                        <img :src="cockpit.img"/>
                    </td>
                    <td>
                        <input class="fullwidth" name="name" placeholder="Name eingeben" v-model="cockpit.name"/>
                    </td>
                    <td>
                        <input class="fullwidth" name="img" placeholder="Url zum Bild" step="1" v-model="cockpit.img"/>
                    </td>
                    <td>
                        <button v-on:click="deleteCockpit(idx)">Löschen</button>
                    </td>
                </tr>
            </table>

            <div style="float: right">
                <button v-on:click="addCockpit">Neues Hinzufügen</button>
                &nbsp;&nbsp;
                <button v-on:click="persistCockpits">Änderungen Speichern</button>
            </div>


        </fieldset>


    </div>
</template>
<script>

	import {mapState} from 'vuex'

	export default {

		computed: mapState(['cockpits']),

		created() {
			this.$store.dispatch('loadCockpitlist');
		},

		methods: {
			addCockpit: function() {
				this.$store.commit('addCockpit');
			},
			deleteCockpit: function(cockpitIdx) {
				this.$store.commit('deleteCockpit', cockpitIdx);
			},
			persistCockpits: function() {
				this.$store.dispatch('persistCockpits');
			}
		}

	}
</script>